import { BookingOrTransactionItemType } from "../../enums/booking-or-transaction-item-type";

export class RequestPermissionNotificationItem {
  constructor() {

  }
  public Id: number;
  public RequestPermissionNotificationId: number;
  public ServiceId: number;
  public ProductId: number;
  public PackageId: number;
  public GiftCardId: number;
  public GymMembershipId: number;
  public VoucherId: number;

  public TotalAmountBeforeDiscount: number;
  public TotalDiscountAmount: number;
  public TotalAmountAfterDiscount: number;
  public TotalAmount: number;

  public ItemGlobalName: string;
  public ItemType: BookingOrTransactionItemType;
}
